import { Button, Drawer, Form, Input, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const EditPosition = ({ open, close, setLoading, rerun, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();

  const handleEditCategory = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/module/edit-position", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Edited product position successfully.");
          setTimeout(() => {
            close();
            form.setFieldsValue({
              position: "",
            });
            setLoadings(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Edit Position"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <Form
          form={form}
          layout="vertical"
          name="basic"
          initialValues={{ position: selectedData.position }}
          onFinish={handleEditCategory}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="position"
              label="Position"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set position" size="large" />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default EditPosition;
